import React from "react";
import {
  Grid,
  Typography,
  Paper,
  Box,
  Container,
  useTheme,
} from "@mui/material";
import InfoSection from "../../shared/InfoSection";
import img from "../../../assets/images/asterisk.png";
import { useTranslation } from "react-i18next";

const FeaturesSection = ({ data = [] }) => {
  const theme = useTheme();
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language;
  return (
    <Box
      sx={{
        py: 5,
        textAlign: "center",
        background: "linear-gradient(1deg, #F4F5F5  10%, #f4f5f52e 100%)",
        mt: { xs: "15px", md: "88px" },
        mb: { xs: "20px", md: "88px" },
      }}
    >
      <Container maxWidth="lg">
        <InfoSection
          icon={img}
          title={t("buttons.Featured")}
          description={t("missed.What makes Berg different")}
          textAlign="center"
        />
        <Grid container spacing={2} justifyContent="space-between" mt={2}>
          {data?.map((feature, index) => (
            <Grid item xs={12} sm={4} md={4} key={index}>
              <Paper
                elevation={0}
                sx={{
                  width: "auto",
                  height: "150px",
                  padding: "24px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  borderRadius: "12px",
                }}
              >
                <Box
                  sx={{
                    bgcolor: theme.palette.primary.yellow,
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mb: 2,
                  }}
                >
                  <Box
                    component="img"
                    src={feature.image}
                    alt={feature.title[currentLang]}
                    loading="lazy" 
                    sx={{
                      width: "24px", 
                      height: "24px", 
                      objectFit: "contain", 
                      borderRadius: "50%", 
                    }}
                  />
                </Box>
                <Typography variant="subtitle1" fontWeight="medium">
                  {feature.title[currentLang]}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default FeaturesSection;
